var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-radio-group',{attrs:{"id":_vm.id,"options":_vm.options,"name":_vm.name,"text-field":_vm.textField,"value-field":_vm.valueField,"disabled":_vm.disabled},on:{"change":_vm.onDataChange},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }